// extracted by mini-css-extract-plugin
export default {"container":"style_container__JdnmR","fadeInDown":"style_fadeInDown__DCtVQ","title":"style_title__oyY7C","buttons":"style_buttons__kY6fp","button":"style_button__ED+T4"};